// 状态徽章：根据状态字符串自动着色
import { statusBadge, severityBadge, type BadgeKind } from '@/lib/format';

const STYLES: Record<BadgeKind, string> = {
  success: 'badge-success',
  warning: 'badge-warning',
  danger: 'badge-danger',
  info: 'badge-info',
  neutral: 'badge-neutral',
};

interface StatusBadgeProps {
  status: string;
  /** 使用 severity 配色（P0/P1/critical/high 等） */
  severity?: boolean;
  label?: string; // 覆盖展示文案
}

export default function StatusBadge({ status, severity, label }: StatusBadgeProps) {
  const kind = severity ? severityBadge(status) : statusBadge(status);
  return <span className={STYLES[kind]}>{label ?? status}</span>;
}
